import {useRef} from 'react';
import './TotpCodeInput.css';

const LENGTH = 6;

const onlyDigits = (value) => String(value ?? '').replace(/\D/g, '').slice(0, LENGTH);

const TotpCodeInput = ({value = '', onChange, disabled = false}) => {
    const cells = Array.from({length: LENGTH}, (_, i) => value[i] || '');
    const refs = useRef([]);

    const emit = (next) => {
        onChange?.(onlyDigits(next));
    };

    const focusAt = (index) => {
        const bounded = Math.max(0, Math.min(LENGTH - 1, index));
        refs.current[bounded]?.focus();
        refs.current[bounded]?.select?.();
    };

    const handleChange = (index, raw) => {
        const digits = onlyDigits(raw);
        if (!digits) {
            const next = cells.slice();
            next[index] = '';
            emit(next.join(''));
            return;
        }
        if (digits.length > 1) {
            const next = cells.join('').slice(0, index) + digits;
            emit(next);
            focusAt(index + digits.length);
            return;
        }
        const next = cells.slice();
        next[index] = digits;
        emit(next.join(''));
        if (index < LENGTH - 1) {
            focusAt(index + 1);
        }
    };

    const handleKeyDown = (index, event) => {
        if (event.key === 'Backspace') {
            if (cells[index]) {
                return;
            }
            event.preventDefault();
            const next = cells.slice();
            if (index > 0) {
                next[index - 1] = '';
                emit(next.join(''));
                focusAt(index - 1);
            }
            return;
        }
        if (event.key === 'ArrowLeft') {
            event.preventDefault();
            focusAt(index - 1);
        }
        if (event.key === 'ArrowRight') {
            event.preventDefault();
            focusAt(index + 1);
        }
    };

    const handlePaste = (event) => {
        event.preventDefault();
        emit(onlyDigits(event.clipboardData.getData('text')));
        focusAt(LENGTH - 1);
    };

    return (
        <div className="totp-code" onPaste={handlePaste}>
            {cells.map((digit, index) => (
                <input
                    key={index}
                    ref={(node) => {
                        refs.current[index] = node;
                    }}
                    className="totp-code__cell"
                    type="text"
                    inputMode="numeric"
                    autoComplete={index === 0 ? 'one-time-code' : 'off'}
                    maxLength={index === 0 ? LENGTH : 1}
                    pattern="[0-9]*"
                    aria-label={`Цифра ${index + 1} з 6`}
                    value={digit}
                    disabled={disabled}
                    onChange={(event) => handleChange(index, event.target.value)}
                    onKeyDown={(event) => handleKeyDown(index, event)}
                    onFocus={(event) => event.target.select()}
                />
            ))}
        </div>
    );
};

export default TotpCodeInput;
